/**
 * 遅延スクロール機能
 * 固定ヘッダーの高さを実測してオフセットを加えてスクロールする。
 * scrollIntoView はヘッダー分を考慮しないため window.scrollTo で制御する。
 */

/**
 * 固定ヘッダーの現在の高さを取得する
 * @returns {number}
 */
function getHeaderHeight() {
  const header = document.querySelector('.m-header');
  return header ? header.getBoundingClientRect().height : 0;
}

/**
 * 対象要素へヘッダーオフセットを考慮してスムーズスクロールする
 * @param {Element} target
 */
function scrollToTarget(target) {
  const headerH = getHeaderHeight();
  const top = target.getBoundingClientRect().top + window.scrollY - headerH;
  window.scrollTo({ top, behavior: 'smooth' });
}

const delayedScroll = () => {
  // document 全体で委譲し、動的生成リンク（目次など）も対応する
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[href*="#"]');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (!href) return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (err) {
      return;
    }

    // 他ページへのリンク（/faq/#xxx 等）は通常遷移させる
    if (
      url.origin !== window.location.origin ||
      url.pathname !== window.location.pathname
    ) {
      return;
    }
    if (!url.hash) return;

    const targetElement = document.querySelector(url.hash);

    if (targetElement) {
      event.preventDefault();
      // 遅延してからスクロール（レイアウト安定化のため）
      setTimeout(() => {
        scrollToTarget(targetElement);
      }, 50);
    }
  });

  /**
   * ページ読み込み時のハッシュ処理
   */
  const handleInitialHash = () => {
    const hash = window.location.hash;
    if (hash && hash !== '#') {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        setTimeout(() => {
          scrollToTarget(targetElement);
        }, 200);
      }
    }
  };

  // ページ読み込み完了後にハッシュ処理を実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialHash);
  } else {
    handleInitialHash();
  }
};

export { delayedScroll };
